import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Table, TableBody, AppBar, CircularProgress, TableCell, Box, TableContainer, TableHead, TableRow, Modal, Paper, Toolbar, Typography, InputAdornment } from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import { useNavigate, useParams } from 'react-router-dom';
import base64 from 'base64-js';
import Tooltip from '@mui/material/Tooltip';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import SearchIcon from "@mui/icons-material/Search";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const Nationality = () => {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [nationalityList, setNationality] = useState([]);
  const [selectedNationality, setSelectedNationality] = useState({ nationalityId: null, nationality: '' });
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();
  const [authorization, setAuthorization] = useState([]);
  const [canDelete, setCanDelete] = useState(true); // Default to true, assuming the user can delete
  const [canEdit, setCanEdit] = useState(true); // Default to true, assuming the user can edit
  const [canAdd, setCanAdd] = useState(true);

  const { encodedFormId } = useParams();

  const decodeFormId = (encodedFormId) => {
    const bytes = base64.toByteArray(encodedFormId);
    return new TextDecoder().decode(bytes);
  };
  const formId = decodeFormId(encodedFormId);
  console.log(formId);

  const handleShow = (nationalityId, nationality) => {
    setSelectedNationality({ nationalityId, nationality });
    setShowModal(true);
  };

  const handleClose = () => {
    setSelectedNationality(null);
    setShowModal(false);
  };

  const handleClick = () => {
    // Placeholder for adding a new nationality
    console.log('ADD NEW nationality');
  };

  const handleDelete = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/Nationality/Id?NationalityId=${selectedNationality.nationalityId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
        }
      );
      if (response.ok) {
        // Handle success, e.g., refresh the data
        fetchNationalityData();
        setShowModal(false);
        setLoadingBarProgress(100);
        setSnackbarMessage('Nationality deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success");
      } else {
        setLoadingBarProgress(0);
        console.error('Delete failed');
        // alert('Failed to delete nationality');
        setSnackbarMessage('Failed to delete nationality!');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleEdit = (nationalityId) => {
    // Placeholder for the edit nationality logic
    navigate(`/editnationality/${nationalityId}`);
  };

  const onClick = () => { };

  const fetchNationalityData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Nationality/GetNationality`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        setLoadingBarProgress(0);
        throw new Error(`Error fetching nationality data: ${response.status}`);
      }

      const nationalityData = await response.json();

      if (nationalityData.data === null && nationalityData.msg === "Record Not Found") {
        setLoadingBarProgress(0);
        console.error('Record Not Found');
        // alert('Record Not Found');
        setSnackbarMessage('Record Not Found');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
        return; // Exit the function if the record is not found
      }

      setNationality(nationalityData);
      setLoadingBarProgress(100);
    } catch (error) {
      setLoadingBarProgress(0);
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          formId,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setAuthorization(responseData);
        // Check permissions for Delete and Edit
        const authorizationData = responseData[0];
        setCanDelete(authorizationData.uDelete === 1);
        setCanAdd(authorizationData.uWrite === 1);
        setCanEdit(authorizationData.uModify === 1);
        setLoadingBarProgress(100);
      } else {
        console.error('Country name incorrect');
        // alert('Invalid country name');
        setSnackbarMessage('Invalid country name');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
        setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  useEffect(() => {
    fetchNationalityData();
    Authorizer();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };

  const filteredData = nationalityList.filter((item) =>
    item.nationality.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Nationality
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

        <form>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '10px' }}>
            <TextField
              variant="outlined"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "300px" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">

                    <SearchIcon />
                  </InputAdornment>
                ),
                style: { padding: '0px 8px' },
              }}
              sx={{
                width: 300,
                backgroundColor: '#f9f9f9',
              }}
            />
            <Tooltip title={canAdd ? "Add Nationality" : "You are not Authorized to Add"} arrow>
              <span><Button
                variant="contained"
                color="primary"
                onClick={() => navigate('/addnationality')}
                style={{
                  width: "160px",
                  height: "50px",
                  padding: "10px 0",
                  fontWeight: 'bold'
                }}
                disabled={!canAdd}

              >
                Add Nationality
              </Button></span></Tooltip>
          </div>


          <TableContainer component={Paper}>
            <Table
              sx={{
                minWidth: 650,
                border: '1px solid #ccc',
                '& .MuiTableCell-root': {
                  borderRight: '1px solid #ccc', // vertical line
                  fontSize: '1rem', // increased font size
                },
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell><strong>Nationality</strong></TableCell>
                  <TableCell style={{ textAlign: 'center' }}><strong>Action</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loadingBarProgress > 0 && loadingBarProgress < 100 ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : paginatedData.length > 0 ? (
                  paginatedData.map((item) => (
                    <TableRow key={item.nationalityId}>
                      <TableCell>{item.nationality}</TableCell>
                      <TableCell style={{ textAlign: 'center' }}>
                        <Tooltip title={canEdit ? 'Edit Nationality' : 'You are not authorized to edit'} arrow>
                          <span>
                            <Button
                              variant="contained"
                              color="warning"
                              style={{ marginLeft: '10px' }}
                              onClick={() => handleEdit(item.nationalityId)}
                              disabled={!canEdit}
                              startIcon={<EditIcon />}
                            >
                              EDIT
                            </Button>
                          </span>
                        </Tooltip>
                        <Tooltip title={canDelete ? 'Delete Nationality' : 'You are not authorized to delete'} arrow>
                          <span>
                            <Button
                              className='mx-2'
                              variant="contained"
                              color="error"
                              onClick={() => handleShow(item.nationalityId, item.nationality)}
                              disabled={!canDelete}
                              startIcon={<DeleteIcon />}
                            >
                              DELETE
                            </Button>
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No Nationalities Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

            </Table>


          </TableContainer>

          {filteredData.length > 0 && (
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
              <TextField
                select
                label="Rows per page"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                sx={{ width: 150 }}
                SelectProps={{
                  native: true,
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </TextField>

              <Box>
                <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                  Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => handleChangePage(null, page - 1)}
                  disabled={page === 1}
                  sx={{ mr: 1 }}
                >
                  Prev
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => handleChangePage(null, page + 1)}
                  disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
                >
                  Next
                </Button>
              </Box>
            </Box>
          )}


          {/* Delete Confirmation Modal */}
          <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                overflow: 'hidden',
              }}
            >
              {/* Header */}
              <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
                <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                  Delete Confirmation ⚠️
                </Typography>
              </Box>

              {/* Content */}
              <Box sx={{ padding: '20px' }}>
                <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                  Are you sure you want to delete <strong>{selectedNationality?.nationality}</strong>?
                </Typography>

                {/* Buttons */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDelete(handleDelete)}
                  >
                    Yes, Delete
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </form>
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default Nationality;
